import Table from '@components/table'
import TableActions from '@components/table/actions'
import Column from '@components/column'
import Fields from '@components/fields'
import Alert from '@commons/popups/alert'
import { LabTest } from '@apis'
import debounce from '@utils/debounce'
import { Formik } from 'formik'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
const LabTestList = () => {
  const { items: labTests } = useSelector((state: any) => state.labTests)
  const navigate = useNavigate()
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    search: '',
  })
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const columns = [
    {
      title: 'Lab Test Name',
      key: 'name',
    },
    {
      title: 'Category',
      key: 'category',
      render: (item) => {
        return item?.category?.name
      },
    },
    {
      title: 'Shortcode',
      key: 'shortcode',
    },
    {
      title: 'Sample Type',
      key: 'sampleTypes',
      render: (item) => {
        return item?.sampleTypes?.map((sample) => sample?.name)?.toString()
      },
    },
    {
      title: 'Active Status',
      key: 'isActive',
      render: (item) => {
        return (
          <Formik
            initialValues={{
              isActive: item?.isActive,
            }}
            onSubmit={() => {}}
          >
            {() => {
              return (
                <Fields.Switch
                  name="isActive"
                  onChange={async (status) => {
                    await LabTest.update({
                      data: {
                        isActive: status,
                      },
                      id: item?.id,
                    }).catch(() => {})
                  }}
                />
              )
            }}
          </Formik>
        )
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item) => {
        return (
          <TableActions
            hasView={false}
            onClickEdit={() => {
              navigate('.', {
                state: item,
              })
            }}
            onClickDelete={() => {
              setDeleteInfo({
                visible: true,
                id: item?.id,
                loading: false,
              })
            }}
          />
        )
      },
    },
  ]

  const fetchData = async (params) => {
    await LabTest.list({
      params,
    }).catch(() => {})
  }

  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await LabTest.remove({
      id: deleteInfo?.id,
    })
      .then(() => {
        navigate('.')
      })
      .catch(() => {})
    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }

  const handleSearch = debounce(async (event: any) => {
    const text = event.target.value
    const updateParams = {
      ...params,
      search: text,
    }
    await fetchData(updateParams)
    setParams(updateParams)
  }, 500)

  useEffect(() => {
    if (!labTests?.length) {
      fetchData(params)
    }
  }, [])

  return (
    <Column>
      <Table
        columns={columns}
        data={labTests}
        filter={{
          hasSearch: true,
          onSearch: handleSearch,
        }}
      />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </Column>
  )
}

export default LabTestList
